<mat-dialog-content class="mat-typography">
    <form [formGroup]="Form" class="example-form">

        <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>Name</mat-label>
            <input matInput formControlName="name" required>
            <!-- <mat-error *ngIf="f.name.invalid">Please enter a name</mat-error> -->
        </mat-form-field>

        <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>Description</mat-label>
            <input matInput formControlName="description" required>
            <!-- <mat-error *ngIf="f.description.invalid">Please enter description</mat-error> -->
        </mat-form-field>

        <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>Select Country</mat-label>
            <mat-select formControlName="coutriesId" (selectionChange)="changeCountryId($event.value)">
              <mat-option *ngFor="let item of countries" [value]="item.id">{{item.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>Select State</mat-label>
            <mat-select formControlName="stateIds" multiple (selectionChange)="changeStateId($event.value)">
              <mat-option *ngFor="let item of states" [value]="item.id">{{item.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>Select Region</mat-label>
            <mat-select formControlName="regionIds" multiple (selectionChange)="changeRegionId($event.value)">
              <mat-option *ngFor="let item of regions" [value]="item.id">{{item.name}}</mat-option>
            </mat-select>
          </mat-form-field>


        <mat-slide-toggle color="primary" formControlName="active">Active</mat-slide-toggle>

    
    </form>  
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <div class="formFooter">
        <button mat-raised-button color="primary" (click)="onSubmit()">Submit</button>
    </div>
</mat-dialog-actions>
